import { useQuery } from 'react-query';

import PESService from 'App/services/PESService';

function useFetchPatientInsurance(patientId) {
    return useQuery(['patient', patientId, 'insurance'], () => PESService.getPatientInsurance(patientId), {
        retry: false,
        refetchInterval: false,
        refetchOnWindowFocus: false,
    });
}

export default useFetchPatientInsurance;
